import { render, staticRenderFns } from "./AddressStickersFormComponent.vue?vue&type=template&id=1937547a&"
import script from "./AddressStickersFormComponent.vue?vue&type=script&lang=js&"
export * from "./AddressStickersFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressStickersFormComponent.vue?vue&type=style&index=0&id=1937547a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports